import { privateAxios } from "@/common/api/axios"
import { UseQueryResult, useQuery } from "@tanstack/react-query"
import { BankingDepositsData } from "../types/bankingDeposits.type";

type UseBankingDepositProps = {
  id: string;
  refetchInterval?: number;
}

type UseBankingDepositType = (props: UseBankingDepositProps) => UseQueryResult<BankingDepositsData, unknown>;

const useBankingDeposit: UseBankingDepositType = ({ id, refetchInterval }) => {
  return useQuery({
    queryKey: ['bankingDeposit', id],
    queryFn: () => privateAxios.get(`/banking/deposits/${id}`),
    select: (data) => data?.data?.data,
    refetchInterval,
  });
}

export default useBankingDeposit;
